import {Injectable, signal} from '@angular/core';
import {FileTypeName, RecordCalendarFileParams} from "../../../../types/file.types";

@Injectable({
  providedIn: 'root'
})
export class MultiFilesParamsService {
  private _multiFileParams = signal<Record<FileTypeName, Array<RecordCalendarFileParams>> | null>(null);
  public multiFileParams = this._multiFileParams.asReadonly();

  public updateMultiFileParams(key: FileTypeName, value: RecordCalendarFileParams): void {
    this._multiFileParams.update(current => {
      const newValue = current ? { ...current } : {} as Record<FileTypeName, Array<RecordCalendarFileParams>>;

      newValue[key] = newValue[key] || [];

      return {
        ...newValue,
        [key]: newValue[key].some(item => item.id === value.id)
          ? newValue[key]
          : [...newValue[key], value]
      };
    });
  }

  public deleteMultiFileParams(key: FileTypeName, id: number): void {
    this._multiFileParams.update(current => {
      if (!current || !current[key]) { return current; }

      const newValue = { ...current };
      newValue[key] = newValue[key].filter(file => file.id !== id);

      if (!newValue[key].length) { delete newValue[key]; }

      return !Object.keys(newValue).length ? null : newValue;
    });
  }

  public resetMultiFileParams(): void {
    this._multiFileParams.set(null);
  }
}
